import React from "react";
import { useNavigate } from "react-router-dom";
import { getOrderDay } from "./pastUnfulfilledUtils";

// Modale riutilizzabile che mostra gli ordini non evasi dei giorni passati.
// Le righe sono cliccabili: portano alla gestione ordini con l'ordine evidenziato.
const PastUnfulfilledModal = ({ open, orders, onClose }) => {
  const navigate = useNavigate();
  if (!open) return null;

  const goToOrder = (orderId) => {
    onClose();
    navigate("/ordersedit", { state: { highlightOrderId: orderId } });
  };

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0,0,0,0.5)",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 2000,
      }}
      onClick={onClose}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: "white",
          padding: "24px",
          borderRadius: "8px",
          maxWidth: "640px",
          width: "90%",
          maxHeight: "80vh",
          overflowY: "auto",
          boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
        }}
      >
        <h3 style={{ marginTop: 0, color: "#dc3545" }}>
          ⚠️ Attenzione: ordini non evasi nei giorni passati
        </h3>
        {orders.length > 0 ? (
          <>
            <p style={{ marginTop: 0, color: "#555" }}>
              Sono presenti {orders.length} ordini con data antecedente a oggi
              ancora da evadere (clicca su una riga per aprire l'ordine):
            </p>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Ordine</th>
                  <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Data</th>
                  <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Sede</th>
                  <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Stato</th>
                  <th style={{ borderBottom: "1px solid #ddd", padding: "8px", textAlign: "left" }}>Autista</th>
                </tr>
              </thead>
              <tbody>
                {orders.map((ord) => (
                  <tr
                    key={ord.orderId}
                    onClick={() => goToOrder(ord.orderId)}
                    style={{ cursor: "pointer" }}
                    onMouseEnter={(e) => (e.currentTarget.style.background = "#f5f5f5")}
                    onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                  >
                    <td style={{ borderBottom: "1px solid #eee", padding: "8px", color: "#007bff", textDecoration: "underline" }}>{ord.orderId}</td>
                    <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{getOrderDay(ord)}</td>
                    <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{ord.sede || "-"}</td>
                    <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{ord.status || "-"}</td>
                    <td style={{ borderBottom: "1px solid #eee", padding: "8px" }}>{ord.autista || "-"}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        ) : (
          <p style={{ color: "#555" }}>Nessun ordine arretrato da evadere. 🎉</p>
        )}
        <div style={{ textAlign: "right", marginTop: "16px" }}>
          <button
            onClick={onClose}
            style={{
              padding: "10px 20px",
              background: "#007bff",
              color: "white",
              border: "none",
              borderRadius: "5px",
              cursor: "pointer",
            }}
          >
            Chiudi
          </button>
        </div>
      </div>
    </div>
  );
};

export default PastUnfulfilledModal;
